import { useSelector } from "react-redux";
import moment from "moment";

export type SubscriptionStatus = "expired" | "expiring_soon" | "active" | "none";

export interface SubscriptionInfo {
  status: SubscriptionStatus;
  daysLeft: number;
  endDate: string | null;
}

export function useSubscriptionCheck(): SubscriptionInfo {
  const user = useSelector((state: any) => state.auth.user);
  const endDate: string | null = user?.subscription_end_date ?? null;

  if (!endDate) {
    return { status: "none", daysLeft: 0, endDate: null };
  }

  const today = moment().startOf("day");
  const expiry = moment(endDate).startOf("day");
  const daysLeft = expiry.diff(today, "days");

  let status: SubscriptionStatus;
  if (daysLeft <= 0) {
    status = "expired";
  } else if (daysLeft <= 3) {
    status = "expiring_soon";
  } else {
    status = "active";
  }

  return { status, daysLeft, endDate };
}
